import { NgModule } from '@angular/core';

import { SharedModule } from 'projects/ProjetoBaseAngular/app/shared.module';
import { ReportModule } from '../../report/report.module';
import { RelPacientesPeriodoComponent } from './rel-pacientes-periodo.component';

@NgModule({
  imports: [
    SharedModule,
    ReportModule
  ],
  declarations: [
    RelPacientesPeriodoComponent,
  ]
})
export class RelPacientesPeriodoModule { }
